import customAxios from "../../customHook/customAxios";
import { getAuthHeader } from "../../utils";

export const v3_inspection_projects = async (page, limit, keyword, groupBy) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/inspection/projects?page=${page}&limit=${limit}&keyword=${keyword}&groupBy=${groupBy}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v3_drawings_count = async (page, limit, keyword, groupBy) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/drawings?page=${page}&limit=${limit}&keyword=${keyword}&groupBy=${groupBy}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}
export const v3_create_inspection = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/inspection`;
    return customAxios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v3_edit_inspection = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/inspection`;
    return customAxios.put(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v3_inspection_project_ships = async (projectId) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/inspection/ship/${projectId}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v3_inspections = async (projectId, shipId, page, limit, filterPayload) => {
    const baseUrl = `${process.env.REACT_APP_BASE_URL}/v3/inspections`;

    const queryParams = new URLSearchParams({
        projectId,
        page: page.toString(),
        limit: limit.toString()
    });

    if (shipId) {
        queryParams.append('shipId', shipId);
    }
    if (filterPayload) {
        queryParams.append('filterPayload', filterPayload);

    }

    const url = `${baseUrl}?${queryParams.toString()}`;

    return customAxios.get(url, getAuthHeader()).then((res) => res.data);
};




export const v3_inspection_Status_Update = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/inspection/status`;
    return customAxios.put(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v3_add_inspection_comment = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/inspection/comment`;
    return customAxios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}



export const v3_add_inspection_attendance = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/inspection/attendance`;
    return customAxios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v3_edit_inspection_attendance = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/inspection/attendance`;
    return customAxios.put(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v3_delete_inspection_attendance = async (attendanceId) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/inspection/attendance/${attendanceId}`;
    return customAxios.delete(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v3_inspection_send_report_mail = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/inspection/reportMail`;
    return customAxios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    });
};
